export const SET_SELECTED_SIDE_BAR = "SET_SELECTED_SIDE_BAR";
export const GET_SELECTED_SIDE_BAR = "GET_SELECTED_SIDE_BAR";

export default {
    SET_SELECTED_SIDE_BAR,
    GET_SELECTED_SIDE_BAR,
}